import { type AiPromptConfig, AiPromptName, aiPromptConfigs } from '@faceup/utils'

type AiPromptDefinition = {
  label: string
  description: string
}

export const aiPromptDefinitions: Record<AiPromptName, AiPromptDefinition> = {
  [AiPromptName.AiHotlineSystemInstructions]: {
    label: 'AI hotline system instructions',
    description: 'System prompt of the AI Voice Agent answering hotline calls.',
  },
  [AiPromptName.DisclosureIntroGeneration]: {
    label: 'Disclosure intro generation',
    description: 'Generates the Intro details of a disclosure form with "Create with AI".',
  },
  [AiPromptName.ChatSpellCheck]: {
    label: 'Chat: spell check',
    description: 'Corrects grammar and spelling of a message before it is sent.',
  },
  [AiPromptName.ChatRewriteFriendly]: {
    label: 'Chat: rewrite friendly',
    description: 'Rewrites a message in a friendlier tone.',
  },
  [AiPromptName.ChatRewriteProfessional]: {
    label: 'Chat: rewrite professional',
    description: 'Rewrites a message in a more professional tone.',
  },
  [AiPromptName.ChatExpandMessage]: {
    label: 'Chat: expand message',
    description: 'Expands a message with more detail.',
  },
}

export const getAiPromptConfig = (name: AiPromptName): AiPromptConfig => aiPromptConfigs[name]

export const hasAiPromptPreview = (name: AiPromptName) => {
  const { variables, conditions } = getAiPromptConfig(name)
  return Object.keys(variables).length > 0 || Object.keys(conditions).length > 0
}
